import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '../../lib/cn';

export default function ExpandableThinking({
  thinking,
  label: labelProp,
  className,
}) {
  const { t } = useTranslation();
  const label = labelProp || t('feedback.showThinking');
  const [isExpanded, setIsExpanded] = useState(false);

  if (!thinking) return null;

  return (
    <div className={className}>
      <button
        type="button"
        onClick={() => setIsExpanded(!isExpanded)}
        className={cn(
          'inline-flex items-center gap-2',
          'text-sm text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200',
          'transition-colors duration-200'
        )}
      >
        <svg
          className={cn(
            'w-4 h-4 transition-transform duration-200',
            isExpanded && 'rotate-180'
          )}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
        <span>{isExpanded ? t('feedback.hideThinking') : label}</span>
      </button>

      <div
        className={cn(
          'overflow-hidden transition-all duration-300 ease-out',
          isExpanded ? 'max-h-96 opacity-100 mt-4' : 'max-h-0 opacity-0'
        )}
      >
        <div
          className={cn(
            'p-4 rounded-lg',
            'bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-800 dark:to-gray-700',
            'border border-gray-200 dark:border-gray-700',
            'text-sm text-gray-600 dark:text-gray-400 leading-relaxed',
            'font-mono'
          )}
        >
          {thinking}
        </div>
      </div>
    </div>
  );
}
